exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-ada0eccc]{max-width:800px}.card-header[data-v-ada0eccc]{padding-left:32px}h1[data-v-ada0eccc]{font-size:1.4rem}h2[data-v-ada0eccc]{font-size:1.2rem}", ""]);

// exports
